import { Division, Span, Flex, Heading, Popover, Button, Icon, Icons } from "@ir/ui";
import { useCallback, useMemo } from "react";
import { PromotionsFilterForm } from "./PromotionsFilterForm";

interface PromotionsFilterPopoverProps {
  isOpenFilterPopover: boolean;
  setIsOpenFilterPopover: (isOpen: boolean) => void;
  filterRef: React.RefObject<HTMLDivElement | null>;
}

const PromotionsFilterPopover = ({
  isOpenFilterPopover,
  setIsOpenFilterPopover,
  filterRef,
}: PromotionsFilterPopoverProps) => {
  const handleFilterOn = useCallback(() => {
    const filterButtonContainer = document.getElementById("promotions-filter-trigger");
    if (filterButtonContainer && isOpenFilterPopover === false) {
      filterButtonContainer.blur();
    }
    setIsOpenFilterPopover(true);
  }, [isOpenFilterPopover, setIsOpenFilterPopover]);

  const popoverTitle = useMemo(
    () => (
      <Flex align="start" justifyContent="space-between" className="px-2">
        <Division>
          <Heading level={5} className="text-primary-900 m-0 font-bold">
            Filters
          </Heading>
          <Span className="sub-title text-grey-500 text-sm">Apply filters to table data</Span>
        </Division>
        <Button variant="clear" color="grey" onPress={() => setIsOpenFilterPopover(false)} noStyle>
          <Icon name={Icons.Close} size="medium" style={{ color: "var(--grey-300)" }} />
        </Button>
      </Flex>
    ),
    [setIsOpenFilterPopover]
  );

  return (
    <Popover
      ref={filterRef}
      isOpen={isOpenFilterPopover}
      placement="bottom right"
      className="filter-popover"
      isNonModal
      shouldCloseOnInteractOutside={() => true}
      title={popoverTitle}
      onOpenChange={setIsOpenFilterPopover}
      content={
        <Division className="filter-popover-content p-2" ref={filterRef}>
          <PromotionsFilterForm closeFilter={() => setIsOpenFilterPopover(false)} />
        </Division>
      }
    >
      <Button
        noStyle
        className="filter-trigger-button"
        id="promotions-filter-trigger"
        onPress={handleFilterOn}
        aria-label="Open filter options"
        htmlTitle="Open Filter Options"
      >
        <Icon name={Icons.FilterLines} size="small" color="grey" />
      </Button>
    </Popover>
  );
};

export { PromotionsFilterPopover };
